export default "__VITE_ASSET__wx3SLrJ2__"